<template>
    <div name="text-label" style="margin-bottom: 11px" class="layout">
        <span class="text">{{text}}<span class="star" v-if="isDefault">*</span></span>
        
    </div>
</template>

<script>
export default {
    name: 'textLabel',
    props: ['isDefault', 'text']
}
</script>

<style scoped>
    .layout {
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;    
    }
    .text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .star {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/TextLabel.vue